import { IGetAllObraInformacoesUseCase } from "../../../presentation/useCases/read/get_all_obra_informacoes_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ObraInformacoes } from "../../models/obra_informacoes";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllInformacaoObraUseCase
 */

export class GetAllObraInformacoesUseCase extends BasePaginatedUseCase<ObraInformacoes> implements IGetAllObraInformacoesUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObraInformacoes(
    idObra: number | undefined,
    data: Date | null,
    informacoes: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObra === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository
      .getAllObraInformacoes(
        idObra,
        data,
        informacoes,
        page,
        rowsPerPage,
      );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
